import { useContext } from "react";
import { MeasuresContext } from "context/MeasuresContext";

export const useMeasures = () => useContext(MeasuresContext);
